import type { HTMLAttributes, ReactNode } from "react";
import { forwardRef } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export interface IFilter {
    id: string;
    filter: ReactNode;
}

interface IFiltersBarProps {
    filters: IFilter[];
}

const FiltersContainerStyle = styled.div`
    display: flex;
    position: relative;
    align-items: stretch;
    border: 1px solid ${colorsPalettes.carbon[50]};

    & > div:not(:last-child) {
        border-right: 1px solid ${colorsPalettes.carbon[50]};
    }

    & > div {
        .DropdownButton--filtersBarDropdownButton {
            border-left: none;
        }
    }
`;

export const FiltersBar = forwardRef<HTMLDivElement, IFiltersBarProps & HTMLAttributes<HTMLDivElement>>(
    ({ filters = [], ...divAttr }, ref) => {
        return (
            <FiltersContainerStyle
                className="FiltersContainer react-filters-container"
                ref={ref}
                {...divAttr}
            >
                {filters.map((filter) => {
                    return <div key={filter.id}>{filter.filter}</div>;
                })}
            </FiltersContainerStyle>
        );
    },
);
